// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Select from 'antd/lib/select';
import Alert from 'antd/lib/alert';
// COMPONENTS
import MoneyInput from 'components/inputs/MoneyInput';
import NumberInput from 'components/inputs/NumberInput';
import styled from 'styled-components';

// CONSTANTS & DESTRUCTURING
// ==========================
const FONT_SIZE = 17;
const Option = Select.Option;

// STYLES
// ==========================
const s = {
  selectInput: {
    display: 'inline-block',
    fontSize: FONT_SIZE,
    width: 170,
    maxWidth: '100%',
    padding: 4,
  },
  textStyle: {
    fontSize: FONT_SIZE,
  },
};

const Container = styled.div`
  align-items: center;
  justify-content: flex-start;
  display: flex;
  margin: ${p => p.theme.margin}px;
  margin-top: 20px;
`;

const AlertContainer = styled.div`
  margin: ${p => p.theme.margin}px;
`;

// EXPORTED COMPONENT
// ==========================
class DiscountSection extends React.PureComponent {
  render() {
    const { record, onChange } = this.props;

    const showTip = record.discountValue === null
      || record.discountValue === '0'
      || record.discountValue === '0.00'
      || record.discountValue === 0;

    return (
      <div>
        <Container>
          {' '}
          Set a
          <span>
            <Select
              onChange={discountType => onChange({ discountType })}
              value={this.props.record.discountType}
              size="large"
              style={s.selectInput}
            >
              <Option style={s.textStyle} value="percentage">
                percentage
              </Option>
              <Option style={s.textStyle} value="dollar-amount">
                dollar amount
              </Option>
            </Select>
          </span>
          discount of
          <span>
            {record.discountType === 'dollar-amount' ? (
              <span
                className="ant-input-group-wrapper ant-input-group-wrapper-lg"
                style={{ marginLeft: 8, width: 100 }}
              >
                <MoneyInput
                  className="ant-input ant-input-lg"
                  style={{ width: 100, fontSize: 17, fontWeight: 500 }}
                  currencySymbol={this.props.currencySymbol}
                  value={record.discountValue}
                  onChange={discountValue => this.props.onChange({ discountValue })}
                />
              </span>
            ) : (
              <span
                className="ant-input-group-wrapper ant-input-group-wrapper-lg"
                style={{ marginLeft: 8, width: 100 }}
              >
                <NumberInput
                  value={record.discountValue}
                  onChange={discountValue => this.props.onChange({ discountValue })}
                />
              </span>
            )}
          </span>
        </Container>
        {showTip ? (
          <AlertContainer>
            <Alert
              message={`Don't need a discount? You can leave the discount value at ${this.props.currencySymbol}0 then.`}
              type="warning"
              closable
              style={{ maxWidth: '100%', width: 425 }}
            />
          </AlertContainer>
        ) : null}
      </div>
    );
  }
}

export default DiscountSection;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/PricingInfo/DiscountSection/index.js